import { makeStyles, Theme, useTheme } from "@material-ui/core/styles";
import {
  Alerts,
  IconButton,
  LightColors,
  Menu,
  MobileMenu,
  Modal,
  Toast,
  Tooltip,
  Typography,
  WebMenuItem,
} from "@thingsw/pitta-design-system";
import clsx from "clsx";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";

import CheckIcon from "@material-ui/icons/Check";
import RefreshIcon from "@material-ui/icons/Refresh";
import VolumeUpIcon from "@material-ui/icons/VolumeUp";
import VolumeOffIcon from "@material-ui/icons/VolumeOff";
import FlipIcon from "@material-ui/icons/Flip";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import FullscreenExitIcon from "@material-ui/icons/FullscreenExit";

import CircularProgress from "@material-ui/core/CircularProgress";
import { useDispatch, useSelector } from "react-redux";

import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CloseIcon from "@material-ui/icons/Close";

import { RootState } from "../../features/store";
import { CAMERA, ICameraInfo } from "../../features/Camera/slice";
import { VolumeSlider } from "./VolumeSlider";
import { toggleFullscreen } from "../../utils/GoogleMap";
import screenfull from "screenfull";
import { updateLiveviewUsage, USER } from "../../features/User/slice";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Webviewer } from "../../contants/Breakpoints";
import { getLbURI } from "../../contants/Server";
import { getDirection } from "../../utils/VOD";
import axios from "axios";
import _ from "lodash";
import { openToast } from "../../features/Toast/slice";
import {
  Direction,
  Front,
  Interior,
  LivePresignURLResult,
  Rear,
  Option,
} from "../../types";
import {
  MODELS_2CH,
  MODELS_3CH,
  OPTION_CAMERA_MODELS,
} from "../../contants/Models";
import Hls from "hls.js";
import { PAYMENT } from "../../features/Payment/slice";
import * as KVSWebRTC from "amazon-kinesis-video-streams-webrtc";
import { useHistory } from "react-router-dom";
import { setError } from "../../features/Error/slice";
import { detect } from "detect-browser";
import { IFirmwareConfig } from "../../contants/Firmwares";
import { getFirmwareConfig } from "../../utils/Firmware";
import MicToggle from "../MicToggle";
import { finishLiveview, LIVEVIEW } from "../../features/LiveView/slice";
import { jwtAxiosInst, sleep } from "../../utils";
import {
  setExitFullscreen,
  setFullscreen as setFullscreenTheme,
  THEME,
} from "../../features/Theme/slice";
// import { RecordRTCPromisesHandler } from "recordrtc";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: "relative",
  },
  fullscreenRoot: {
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    zIndex: 9999,
    backgroundColor: "black",
  },
  videoDiv: {
    width: "100%",
    position: "relative",
    overflow: "visible",
    paddingTop: "min(56.25%, 720px)",
    backgroundColor: "black",
    // paddingTop:
    //   "max(350px, calc(100vh - 108px - 188px - 24px - 24px - 49px - 16px))",
  },
  videoDivApp: {
    paddingTop: "min(56.25%, 720px)",
  },
  videoDivAppLandscape: {
    paddingTop: "80vh",
  },
  multiViewDiv: {
    // paddingTop: "220px",
    // paddingTop: "34vh",
    paddingTop: "56.25%",
  },
  videoInner: {
    width: "min(100%, 1280px)",
    paddingTop: "min(56.25%, 720px)",
  },
  video: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    // transform: "translateX(-50%)",
    // width: "fit-content",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: `${LightColors.primary["1"]}4D`,
    overflow: "hidden",
  },
  twoWayAlert: {
    position: "absolute",
    top: 8,
    right: 12,
  },
  twoWayAlertMulti: {
    top: 58,
  },
  addCameraDiv: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: LightColors.primary["6"],
    border: `1px solid ${LightColors.primary["4"]}`,
    zIndex: 2,
  },
  addCameraBtn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: LightColors.primary["7"],
    "-webkit-touch-callout": "none" /* iOS Safari */,
    "-webkit-user-select": "none" /* Safari */,
    "-khtml-user-select": "none" /* Konqueror HTML */,
    "-moz-user-select": "none" /* Old versions of Firefox */,
    "-ms-user-select": "none" /* Internet Explorer/Edge */,
    "user-select": "none",
    /* Non-prefixed version, currently
       supported by Chrome, Edge, Opera and Firefox */
    cursor: "pointer",
    "&:hover": {
      color: LightColors.primary["8"],
    },
    "&:active": {
      color: LightColors.primary["8"],
    },
  },
  videoHFlip: {
    "-webkit-transform": "scale(-1, 1)",
    transform: "scale(-1, 1)",
  },
  videoVFlip: {
    "-webkit-transform": "scale(1, -1)",
    transform: "scale(1, -1)",
  },
  videoFlip: {
    "-webkit-transform": "scale(-1, -1)",
    transform: "scale(-1, -1)",
  },
  ctrlContDiv: {
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    left: 0,
    bottom: 0,
    right: 0,
    padding: theme.spacing(0, 1),
    zIndex: 1,
  },
  blackvueIcon: {
    width: 160,
    height: 29,
    fill: LightColors.primary["0"],
  },
  circularLoading: {
    color: LightColors.primary["0"],
  },
  overlayDiv: {
    background:
      "linear-gradient(180deg, rgba(19, 19, 28, 0) 66.22%, rgba(19, 19, 28, 0.75) 95.5%)",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  ctrlDiv: {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(1, 0),
  },
  ctrlIcon: {
    padding: 0,
    marginRight: theme.spacing(1),
    color: LightColors.primary["0"],
    fill: LightColors.primary["0"],
    "&>svg": {
      color: LightColors.primary["0"],
      fill: LightColors.primary["0"],
    },
    "&.Mui-disabled": {
      color: `${LightColors.primary["0"]}40`,
      fill: `${LightColors.primary["0"]}40`,
    },
  },
  volumeCtrlDiv: {
    width: 52,
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(1),
  },
  playerMenuDiv: {
    backgroundColor: LightColors.primary["1"],
    color: LightColors.primary["0"],
    boxShadow:
      "0px 6px 20px rgba(0, 0, 0, 0.05), 0px 3px 15px rgba(0, 0, 0, 0.1), 0px 0px 8px rgba(0, 0, 0, 0.08)",

    "& svg": {
      color: LightColors.primary["0"],
      fill: LightColors.primary["0"],
    },
  },
  webMenuDiv: {
    "&:hover": {
      backgroundColor: LightColors.primary["2"],
    },
  },
  mobileMemuItem: {
    padding: theme.spacing(1.5, 2),
  },
  menuDiv: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 80,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: `${LightColors.primary["1"]}73`,
    color: LightColors.primary["0"],
    padding: theme.spacing(1.125, 1),
    // "& svg": {
    //   fill: LightColors.primary["0"],
    // },
    textShadow:
      "0px 0px 1px rgba(0, 0, 0, 0.14), 0px 1px 1px rgba(0, 0, 0, 0.12), 0px 0px 3px rgba(0, 0, 0, 0.2)",
  },
  dirDiv: {
    display: "flex",
    alignItems: "center",
    // mantis - 8362, 다국어 번역시 ui겹침 수정
    // width: 62,
    cursor: "pointer",
  },
  selectedOverlay: {
    border: `3px solid ${LightColors.secondary["17"]}`,
  },
  videoFullScreen: {
    paddingTop: "calc(var(--vh, 1vh) * 100)",
  },
  mobilePlayCtrlDiv: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: `${LightColors.primary["1"]}73`,
  },
  mobilePlayCtrl: {
    display: "flex",
    minWidth: 216,
    justifyContent: "center",
    alignItems: "center",
  },
  disabledCtrlIcon: {
    padding: 0,
    marginRight: theme.spacing(1),
    "&>svg": {
      color: `${LightColors.primary["0"]}40`,
      fill: `${LightColors.primary["0"]}40`,
    },
    display: "flex",
  },
  uncheckedMenu: {
    paddingLeft: 44,
  },
  disabled: {
    color: `${LightColors.primary["0"]}40`,
    fill: `${LightColors.primary["0"]}40`,
  },
  ctrlContDivFullscreenApp: {
    paddingBottom: 60,
  },
}));

class CustomSigner implements KVSWebRTC.RequestSigner {
  // 클래스를 정의
  url: string;

  constructor(_url: string) {
    this.url = _url;
  }

  async getSignedURL(
    signalingEndpoint: string,
    queryParams: KVSWebRTC.QueryParams,
    date?: Date
  ) {
    return this.url;
  }
}

interface LiveViewPlayerProps {
  direction: 1 | 2 | 3 | undefined;
  camera?: ICameraInfo;
  main?: boolean;
  multiView?: boolean;
  disabled?: boolean;
  isPublic?: boolean;
  // windows chrome에서 click action없이 mute안된 상태로 영상재생하면 재생안됨
  // https://developer.chrome.com/blog/autoplay/
  clicked?: boolean;
  onAddCamera?: () => void;
  onMenuOpen?: () => void;
  menuAnchorRef?: React.RefObject<HTMLDivElement>;
  selected?: boolean;
  onClose?: () => void;
  onChannelChange: (dir: Direction, failed?: boolean) => void;
  enableMic?: boolean;
  micBtnDisabled?: boolean;
  twoWayInUse?: boolean;
  app?: boolean;
  landscape?: boolean;
  onToggleMic?: () => void;
  onAudioLevelChanged?: (level: number) => void;
  onNoMicPerm?: (ignore?: boolean) => void;
  onChangePlaying?: (playing: boolean) => void;
  modal?: boolean;
  loadingTwoWay?: boolean;
}

export const LiveViewPlayer = (props: LiveViewPlayerProps) => {
  const {
    direction,
    camera,
    main,
    multiView,
    disabled,
    menuAnchorRef,
    selected,
    isPublic,
    onAddCamera,
    onClose,
    onChannelChange,
    enableMic,
    micBtnDisabled,
    twoWayInUse,
    app,
    landscape,
    onToggleMic,
    onAudioLevelChanged,
    onNoMicPerm,
    onChangePlaying,
    // modal,
    onMenuOpen,
    loadingTwoWay,
  } = props;
  const classes = useStyles(props);
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const mobile = useMediaQuery(theme.breakpoints.down(Webviewer.mobile));
  // mantis : 7394
  // Live view 연결 끊겼을 때, 모달 발생 & 페이지 이동을 위한 useHistory
  const history = useHistory();

  const prevDirectionRef = useRef(direction);
  //remteView
  const remoteView = useRef<HTMLVideoElement>(null);
  const fullScreenRef = useRef<any>(null);
  const videoRef = useRef<HTMLDivElement>(null);
  const volumeAnchorRef = useRef<HTMLButtonElement>(null);
  const flipAnchorRef = useRef<HTMLButtonElement>(null);
  const disconnectedRef = useRef(false);
  const stopLiveview = useRef(false);
  const clientIDRef = useRef<string | null>(null);
  const audioAnimationRef = useRef<number | null>(null);
  const audioStreamRef = useRef<MediaStream | null>(null);
  const sendingSDPRef = useRef(false);
  const receivedSDPRef = useRef(false);
  const nTrySendSDPRef = useRef(0);
  const retryTimer = useRef<number>();

  const usedTimeRef = useRef(0);
  const multiviewRef = useRef(false);

  // const { firmwareConfig } = useSelector((state: RootState) => state[CAMERA]);

  const { email, loginInfo, usageInfo, tokenType, userProfile } = useSelector(
    (state: RootState) => state[USER]
  );
  const { subscriptionInfo } = useSelector(
    (state: RootState) => state[PAYMENT]
  );
  const { publicCams } = useSelector((state: RootState) => state[CAMERA]);
  const { removePlayer } = useSelector((state: RootState) => state[LIVEVIEW]);
  const { exitFullscreen } = useSelector((state: RootState) => state[THEME]);

  const [dir /*, setDir*/] = useState(direction);
  const [openFlipMenu, setOpenFlipMenu] = useState(false);
  const [openVolumeMenu, setOpenVolumeMenu] = useState(false);
  const [hFlip, setHFlip] = useState(false);
  const [vFlip, setVFlip] = useState(false);
  const [loading, setLoading] = useState(true);
  // click 이벤트가 발생한 경우, default volume으로 아닌 경우 mute
  const [volume, setVolume] = useState(0);
  const [preVolume, setPreVolume] = useState(0);
  const [fullscreen, setFullscreen] = useState(false);
  const [refresh /*, setRefresh*/] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [hlsInst, setHlsInst] = useState<Hls>();
  const [openTooltip, setOpenTooltip] = useState(false);
  const [disableVolume, setDisableVolume] = useState(false);
  // 7027 - 방향 전환 시, 5초간 방향전환 못하게 수정
  const [disableDir, setDisableDir] = useState(false);
  // CLOUD NATIVE 서버 에러 표시
  const [serverError, setServerError] = useState(false);

  const [playing, setPlaying] = useState(false);
  const [muted, setMuted] = useState(true);
  // mantis : 7394
  // Live view 연결 끊겼을 때, 모달 open useState
  const [liveModal, setLiveModal] = useState(false);
  const [camStatus, setCamStatus] = useState("on");
  const [firmwareConfig, setFirmwareConfig] = useState<IFirmwareConfig>();
  const [audioLevel, setAudioLevel] = useState(0);
  const [directionChangeFailed, setDirectionChangeFailed] = useState(false);

  const [openMuteTooltip, setOpenMuteTooltip] = React.useState(false);
  const [openUnMuteTooltip, setOpenUnMuteTooltip] = React.useState(false);
  const [autoPlayable /*, setAutoPlayable*/] = useState<boolean>(false);

  const [openUnplugged, setOpenUnplugged] = useState(false);
  const [presignedUrl, setPresignedUrl] = useState<LivePresignURLResult>();
  const [readyToConnect, setReadyToConnect] = useState(false);

  const dr750x3chplus = useMemo(() => {
    return camera?.model === "DR750X-3CH Plus";
  }, [camera?.model]);

  const HD_LIVEVIEW = useMemo(() => {
    if (firmwareConfig === undefined) {
      return undefined;
    }
    return !!firmwareConfig?.HDLiveview;
  }, [firmwareConfig]);

  const remoteTransform = useMemo(() => {
    if (HD_LIVEVIEW) {
      return "scale(1,1)";
    }
    if (fullscreen) {
      return "scale(1,0.833)";
    }

    //DR750X-3CH Plus 모델은 라이브뷰 영상 비율(640x480)이 다른 대시캠과 달라서 예외처리
    if (dr750x3chplus) {
      return "scale(1.325,1)";
    }
    return "scale(1.2,1)";
  }, [HD_LIVEVIEW, dr750x3chplus, fullscreen]);

  useEffect(() => {
    multiviewRef.current = !!multiView;
  }, [multiView]);

  // useEffect(() => {
  //   const browser = detect();
  //   console.log("CloudNative", "browser", browser);
  //   if (
  //     app ||
  //     browser?.name === "ios" ||
  //     (browser?.name === "chrome" && browser?.os === "Android OS")
  //   ) {
  //     setAutoPlayable(false);
  //   } else {
  //     canAutoPlay.audio({ timeout: 10000 }).then(({ result, error }) => {
  //       console.log("CloudNative", "audio", "canAutoPlay", result, error);
  //       setAutoPlayable(result);
  //     });
  //   }
  // }, [app]);

  useEffect(() => {
    onChangePlaying?.(playing);
  }, [onChangePlaying, playing]);

  // mantis - 9178, 웹 제외. 모든 툴팁 최초 진입시에만 노출(Leehj).
  useEffect(() => {
    if (app || mobile) {
      setOpenMuteTooltip(true);
      setTimeout(() => setOpenMuteTooltip(false), 3000);

      setOpenUnMuteTooltip(true);
      setTimeout(() => setOpenUnMuteTooltip(false), 3000);
    }
  }, [app, mobile]);

  const iosBrowser = useMemo(() => {
    const browser = detect();
    return browser?.name === "ios" || browser?.name === "crios";
  }, []);

  const browserName = useMemo(() => {
    return detect()?.name;
  }, []);

  useEffect(() => {
    if (!removePlayer) {
      disconnectedRef.current = false;
    }
  }, [removePlayer]);

  useEffect(() => {
    if (directionChangeFailed) {
      const timer = setTimeout(() => {
        setDirectionChangeFailed(false);
      }, 2000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [directionChangeFailed]);

  useEffect(() => {
    onAudioLevelChanged?.(audioLevel);
  }, [audioLevel, onAudioLevelChanged]);

  useEffect(() => {
    if (!enableMic) {
      if (audioAnimationRef.current) {
        clearInterval(audioAnimationRef.current);
      }
      setAudioLevel(0);
    } else {
      setMuted(false);
      if (mobile) {
        setVolume(100);
      } else {
        setVolume(50);
      }
    }
  }, [enableMic, mobile]);

  useEffect(() => {
    return () => {
      setAudioLevel(0);
      if (audioAnimationRef.current) {
        console.log("CloudNative", "cancelAnimationFrame");
        clearInterval(audioAnimationRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (camera) {
      const config = getFirmwareConfig(camera);
      setFirmwareConfig(config);
    }
  }, [camera]);

  useEffect(() => {
    if (camStatus === "off") {
      if (app) {
        //10670 - 앱에서는 앱이 모달 표시하도록 수정 (mckim)
        dispatch(finishLiveview("DEVICE_DISCONNECT"));
      } else {
        // mantis : 7394
        // Live view 연결 끊겼을 때, 모달 open
        setLiveModal(true);
      }
      setLoading(false);
      remoteView.current?.pause();
    }
  }, [app, camStatus, dispatch]);

  useEffect(() => {
    if (isPublic) {
      const found = _.find(publicCams, (dev) => dev.psn === camera?.psn);
      if (found?.active === "off") {
        // mantis : 7394
        // Live view 연결 끊겼을 때, 현재 연결 상태를 off로 변경
        setCamStatus("off");
      }
    }
  }, [camera?.psn, isPublic, publicCams]);

  //Blackvue7 Box 옵션 카메라 방향 추가 (8460)
  const isOptionModel = useMemo(
    () => _.includes(OPTION_CAMERA_MODELS, camera?.model),
    [camera?.model]
  );

  // 7027 - 방향 전환 시, 5초간 방향전환 못하게 수정
  useEffect(() => {
    if (disableDir) {
      const timerId = setTimeout(() => {
        setDisableDir(false);
      }, 5000);
      return () => {
        clearTimeout(timerId);
      };
    }
  }, [disableDir]);

  //webrtc 연결용
  const peerConnection = useRef<RTCPeerConnection | null>(null);
  const signalingClient = useRef<KVSWebRTC.SignalingClient | null>(null);
  const localView = useRef<HTMLVideoElement | null>(null);
  const localStream = useRef<MediaStream | null>(null);
  const remoteStream = useRef<MediaStream | null>(null);

  const CLOUD_NATIVE = useMemo(() => {
    console.log("CloudNative", "firmwareConfig", firmwareConfig);
    if (firmwareConfig === undefined) {
      return undefined;
    }
    return !!firmwareConfig?.CloudNative;
  }, [firmwareConfig]);

  const resetConnection = useCallback(async () => {
    console.log("resetConnection", CLOUD_NATIVE, camera);
    // if (!CLOUD_NATIVE || !camera) return;
    if (!camera) return;

    const cam = camera;
    const p = remoteView.current;
    const local = localView.current;
    console.log(
      "CloudNative",
      "clientID",
      clientIDRef.current,
      "start removing connection..."
    );
    disconnectedRef.current = true;
    if (audioStreamRef.current) {
      console.log(
        "CloudNative",
        "clientID",
        clientIDRef.current,
        "sending TwoWayStop to",
        cam.psn
      );
      audioStreamRef.current.getTracks().forEach((track) => track.stop());
      audioStreamRef.current = null;
      jwtAxiosInst.post(`/IoT/devicecommand`, {
        command: "TwoWayStop",
        email,
        user_token: loginInfo?.user_token,
        tokenType: tokenType,
        psn: cam.psn,
      });
    }

    await sleep(1500);

    if (!sendingSDPRef.current) {
      // kvs 채널 연결이 정상적으로 되지 않은 경우를 대비해 Stop메시지 추가로 보냄 (20220714)
      // TwoWayStart한 경우는 라이브뷰 정상연결된 경우로 StopLiveView 안보냄
      console.log(
        "CloudNative",
        "clientID",
        clientIDRef.current,
        "sending StopLiveView to",
        cam.psn
      );
      jwtAxiosInst.post(`/IoT/devicecommand`, {
        command: "StopLiveView",
        email,
        user_token: loginInfo?.user_token,
        tokenType: tokenType,
        psn: cam.psn,
      });
    }

    console.log(
      "CloudNative",
      "clientID",
      clientIDRef.current,
      "removing webrtc...",
      cam.psn
    );
    p?.pause();
    local?.pause();
    setHlsInst(undefined);
    setPresignedUrl(undefined);
    setReadyToConnect(false);

    console.log(
      "CloudNative",
      "clientID",
      clientIDRef.current,
      "close signaling client...",
      cam.psn,
      signalingClient.current
    );
    // webrtc 정리
    if (signalingClient.current) {
      signalingClient.current.close();
      signalingClient.current = null;
    }

    if (peerConnection.current) {
      peerConnection.current.close();
      peerConnection.current = null;
    }

    if (localStream.current) {
      localStream.current.getTracks().forEach((track) => track.stop());
      localStream.current = null;
    }

    if (remoteStream.current) {
      remoteStream.current.getTracks().forEach((track) => track.stop());
      remoteStream.current = null;
    }

    if (local) {
      local.srcObject = null;
    }

    if (p) {
      p.srcObject = null;
    }

    setLoading(true);
    setReadyToConnect(false);

    disconnectedRef.current = false;
  }, [CLOUD_NATIVE, camera, email, loginInfo?.user_token, tokenType]);

  const exitAppFullscreen = useCallback(() => {
    fullScreenRef.current.fullscreen = false;
    setFullscreen(fullScreenRef.current.fullscreen);
    // mantis - 10092, 카메라 방향 드롭박스가 open된 채로 전체화면을 나가면 전체화면이 아닐 때 출력되는 카메라 방향 드롭박스를 열어준다. (Leehj)
    if (openMenu && !multiView) {
      onMenuOpen?.();
    }
    // mantis - 10092, 전체화면을 나가면 전체화면에서만 사용중인 카메라 방향 드롭박스를 닫아준다. (Leehj)
    if (!multiView) {
      setOpenMenu(false);
    }
    if (
      browserName === "ios-webview" &&
      //@ts-ignore
      webkit.messageHandlers.disableRotate
    ) {
      //@ts-ignore
      webkit.messageHandlers.disableRotate.postMessage({});
    }
    if (
      browserName === "chromium-webview" &&
      //@ts-ignore
      window.Webviewer?.disableRotate
    ) {
      //@ts-ignore
      window.Webviewer?.disableRotate?.();
    }
  }, [browserName, multiView, onMenuOpen, openMenu]);

  //@ts-ignore
  window.exitFullScreen = useCallback(() => {
    console.log(
      "LiveViewPlayer",
      "window.exitFullScreen",
      fullScreenRef.current
    );
    if (fullScreenRef.current) {
      exitAppFullscreen();
    }
  }, [exitAppFullscreen]);

  // Free 계정 & 라이브뷰 제한까지 사용하면 Loading = false
  useEffect(() => {
    if (subscriptionInfo?.servicePlanName === "free") {
      if (usageInfo && usageInfo.liveViewDayUsage >= usageInfo.LimitLiveView) {
        setLoading(false);
      }
    }
  }, [subscriptionInfo?.servicePlanName, usageInfo]);

  useEffect(() => {
    if (camera && isPublic) {
      // 공유된 카메라의 share_audio가 on이 아니면 mute시키고 volume controller disable
      if (camera.share_audio !== "on") {
        setVolume(0);
        setDisableVolume(true);
      }
    }
  }, [camera, isPublic]);

  useEffect(() => {
    return () => {
      if (camera && usedTimeRef.current > 0) {
        dispatch(
          updateLiveviewUsage({
            psn: camera.psn,
            usage: Math.round(usedTimeRef.current),
          })
        );
      }
    };
  }, [camera, dispatch]);

  useEffect(() => {
    const checkPaused = () => {
      if (!remoteView.current?.paused) {
        // ref.current?.play();
        setLoading(false);
        setPlaying(true);
      }
    };
    const timer = setInterval(checkPaused, 500);
    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    const updateUsedTime = () => {
      usedTimeRef.current = usedTimeRef.current + 0.2;
      if (usageInfo && usageInfo.LimitLiveView > 0 && camera) {
        if (
          usageInfo.liveViewDayUsage + usedTimeRef.current >=
          usageInfo.LimitLiveView
        ) {
          console.log("updateUsedTime", "pause");
          remoteView.current?.pause();
          hlsInst?.stopLoad();
          // hlsInst?.detachMedia();
          // setHlsInst(undefined);
          setPlaying(false);
          setLoading(false);
          if (usedTimeRef.current > 0) {
            dispatch(
              updateLiveviewUsage({
                psn: camera.psn,
                usage: Math.round(usedTimeRef.current),
              })
            );
          }
          usedTimeRef.current = 0;
        }
      }
    };
    if (playing) {
      const timer = setInterval(updateUsedTime, 200);
      return () => {
        clearInterval(timer);
      };
    }
  }, [camera, dispatch, hlsInst, playing, usageInfo]);

  useEffect(() => {
    const changeDirection = async (cam: ICameraInfo, cdir: 1 | 2 | 3) => {
      if (!direction) return;
      if (CLOUD_NATIVE) {
        const resp = await jwtAxiosInst.post(`/IoT/devicecommand`, {
          command: "LiveDirection",
          email,
          user_token: loginInfo?.user_token,
          tokenType: tokenType,
          psn: camera?.psn,
          param1: `${cdir}`,
        });

        let data: any;
        if (typeof resp.data === "string") {
          data = JSON.parse(resp.data ?? "{}");
        } else {
          data = resp.data;
        }
        console.log("CloudNative", "changeDirection", data);

        if (data.resultcode === "BC_ERR_OK") {
          if (data.status === "busy") {
            prevDirectionRef.current = parseInt(data.direction) as 1 | 2 | 3;
            onChannelChange(prevDirectionRef.current, true);

            dispatch(openToast({ message: "Please try again later." }));
          } else {
            prevDirectionRef.current = cdir;
          }
        } else if (data.resultcode === "BC_ERR_UNPLUGED") {
          //  mantis - 9266, 전체화면시에도 토스트팝업 노출되도록 수정(Leehj)
          if (fullscreen) {
            setOpenUnplugged(true);
          } else {
            dispatch(openToast({ message: "Camera is unplugged" }));
          }
          onChannelChange(prevDirectionRef.current ?? 1, true);
          setDisableDir(false);
        } else if (data.resultcode === "BC_ERR_TIMEOUT") {
          console.log("CloudNative", "device command", "Request Timeout");
          dispatch(setError("Request Timeout"));
        }
      } else {
        const server_name = getLbURI(cam.lb_server_name, cam.lb_http_port);
        try {
          await axios.get(
            `${server_name}/proc/live_direction?email=${email}&user_token=${loginInfo?.user_token}&psn=${cam.psn}&direction=${cdir}&tokenType=web`
          );
          prevDirectionRef.current = direction;
          onChannelChange(direction);
        } catch (err) {
          if (err.response?.status === 421) {
            dispatch(openToast({ message: "Camera is unplugged" }));
          } else {
            dispatch(openToast({ message: "Please check the connection_" }));
          }
          onChannelChange(prevDirectionRef.current ?? 1, true);
          setDisableDir(false);
        }
      }
    };
    console.log(
      "CloudNative",
      CLOUD_NATIVE,
      "changing direction is requested",
      "direction",
      direction,
      "prevDirectionRef.current",
      prevDirectionRef.current
    );
    if (camera && prevDirectionRef.current !== direction) {
      changeDirection(camera, direction ?? 1);
    }
  }, [
    CLOUD_NATIVE,
    camera,
    direction,
    dispatch,
    email,
    fullscreen,
    loginInfo?.user_token,
    onChannelChange,
    tokenType,
  ]);

  useEffect(() => {
    function exitHandler(evt: any) {
      let fullscreenElement =
        document.fullscreenElement || document.webkitCurrentFullScreenElement;
      console.log(
        "LiveViewPlayer",
        "exitHandler",
        evt,
        fullScreenRef.current.fullscreen,
        fullscreenElement
      );
      if (fullScreenRef.current && !fullscreenElement) {
        exitAppFullscreen();
      }
      setOpenTooltip(false);
    }
    if (screenfull.isEnabled) {
      screenfull.on("change", exitHandler);

      return () => {
        //@ts-ignore
        screenfull.off("change", exitHandler);
      };
    }
  }, [browserName, exitAppFullscreen]);

  const handleChangeChannel = useCallback(
    (dir: Direction) => {
      console.log("CloudNative", "handleChangeChannel", dir);
      // 7027 - 방향 전환 시, 5초간 방향전환 못하게 수정
      if (dir !== direction) {
        setDisableDir(true);
      }
      setOpenMenu(false);
      onChannelChange(dir);
    },
    [direction, onChannelChange]
  );

  const directionMenuMarkup = useMemo(() => {
    if (camera) {
      const dir = direction ?? 1;
      //Blackvue7 Box 옵션 카메라 방향 추가 (8460)
      let direction3rd: JSX.Element | undefined = undefined;
      if (_.includes(MODELS_3CH, camera.model)) {
        if (isOptionModel) {
          direction3rd = (
            <WebMenuItem
              key="direction-option"
              startIcon={
                !mobile && dir === Option && <CheckIcon fontSize="small" />
              }
              endIcon={
                mobile && dir === Option && <CheckIcon fontSize="small" />
              }
              className={clsx({
                [classes.uncheckedMenu]: dir !== Option && !mobile,
                [classes.mobileMemuItem]: mobile,
              })}
              onClick={() => {
                handleChangeChannel(Option);
              }}
            >
              {t("Option")}
            </WebMenuItem>
          );
        } else {
          direction3rd = (
            <WebMenuItem
              key="direction-interior"
              startIcon={
                !mobile && dir === Interior && <CheckIcon fontSize="small" />
              }
              endIcon={
                mobile && dir === Interior && <CheckIcon fontSize="small" />
              }
              className={clsx({
                [classes.uncheckedMenu]: direction !== Interior && !mobile,
                [classes.mobileMemuItem]: mobile,
              })}
              onClick={() => {
                handleChangeChannel(Interior);
              }}
            >
              {t("Interior")}
            </WebMenuItem>
          );
        }
      }

      return _.compact([
        <WebMenuItem
          key="direction-front"
          startIcon={!mobile && dir === Front && <CheckIcon fontSize="small" />}
          endIcon={mobile && dir === Front && <CheckIcon fontSize="small" />}
          className={clsx({
            [classes.uncheckedMenu]: dir !== Front && !mobile,
            [classes.mobileMemuItem]: mobile,
          })}
          onClick={() => {
            handleChangeChannel(Front);
          }}
        >
          {t("Front")}
        </WebMenuItem>,
        _.includes([...MODELS_2CH, ...MODELS_3CH], camera.model) && (
          <WebMenuItem
            key="direction-rear"
            startIcon={
              !mobile && dir === Rear && <CheckIcon fontSize="small" />
            }
            endIcon={mobile && dir === Rear && <CheckIcon fontSize="small" />}
            className={clsx({
              [classes.uncheckedMenu]: dir !== Rear && !mobile,
              [classes.mobileMemuItem]: mobile,
            })}
            onClick={() => {
              handleChangeChannel(Rear);
            }}
          >
            {t("Rear")}
          </WebMenuItem>
        ),
        direction3rd,
      ]);
    }
  }, [
    camera,
    classes.mobileMemuItem,
    classes.uncheckedMenu,
    direction,
    handleChangeChannel,
    isOptionModel,
    mobile,
    t,
  ]);

  const handleFullscreen = useCallback(() => {
    console.log("CloudNative", "handleFullscreen", detect());
    // alert(JSON.stringify(detect()));
    if (iosBrowser) {
      setFullscreen((f) => !f);
    } else if (fullScreenRef.current) {
      toggleFullscreen(fullScreenRef.current);
      dispatch(setFullscreenTheme(fullScreenRef.current.fullscreen));
      console.log(
        "LiveViewPlayer",
        "handleFullscreen",
        fullScreenRef.current.fullscreen
      );
      if (app) {
        if (fullScreenRef.current.fullscreen) {
          if (
            browserName === "ios-webview" &&
            //@ts-ignore
            webkit.messageHandlers.enableRotate
          ) {
            //@ts-ignore
            webkit.messageHandlers.enableRotate.postMessage({});
          }
          if (
            browserName === "chromium-webview" &&
            //@ts-ignore
            window.Webviewer?.enableRotate
          ) {
            //@ts-ignore
            window.Webviewer?.enableRotate?.();
          }
        } else {
          if (
            browserName === "ios-webview" &&
            //@ts-ignore
            webkit.messageHandlers.disableRotate
          ) {
            //@ts-ignore
            webkit.messageHandlers.disableRotate.postMessage({});
          }
          if (
            browserName === "chromium-webview" &&
            //@ts-ignore
            window.Webviewer?.disableRotate
          ) {
            //@ts-ignore
            window.Webviewer?.disableRotate?.();
          }
        }
      }

      setFullscreen(fullScreenRef.current.fullscreen);
      setOpenTooltip(false);
    }
  }, [app, browserName, dispatch, iosBrowser]);

  useEffect(() => {
    if (exitFullscreen) {
      if (iosBrowser) {
        setFullscreen(false);
      } else {
        if (fullScreenRef?.current.fullscreen) {
          handleFullscreen();
        }
      }
      dispatch(setExitFullscreen(undefined));
    }
  }, [dispatch, exitFullscreen, handleFullscreen, iosBrowser]);

  useEffect(() => {
    if (remoteView.current) {
      if (multiviewRef.current) {
        if (selected) {
          remoteView.current.volume = volume / 100;
          if (volume !== 0) {
            setMuted(false);
          }
        } else {
          remoteView.current.volume = 0;
          setMuted(true);
        }
      } else {
        remoteView.current.volume = volume / 100;
      }
    }
    // console.log(
    //   "CloudNative",
    //   "clicked",
    //   selected,
    //   volume,
    //   remoteView.current?.volume
    // );
  }, [selected, volume]);

  useEffect(() => {
    if (multiviewRef.current) {
      if (selected) {
        setVolume(50);
      } else {
        setVolume(0);
      }
      setPreVolume(50);
    }
  }, [selected]);

  const startPlay = useCallback(async () => {
    if (camera && remoteView.current && email && loginInfo && !disabled) {
      const server_name = getLbURI(camera.lb_server_name, camera.lb_http_port);
      const videoSrc = `${server_name}/proc/hls_live.m3u8?email=${email}&user_token=${
        loginInfo.user_token
      }&tokenType=web&psn=${camera.psn}&direction=${dir ?? 1}`;
      const video = remoteView.current;

      if (dir === undefined) {
        prevDirectionRef.current = 1;
        onChannelChange(1);
      }

      if (Hls.isSupported()) {
        var hls = new Hls();
        setHlsInst(hls);

        hls.loadSource(videoSrc);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          video.play();
        });
        hls.on(Hls.Events.ERROR, function (err, data) {
          console.log("hls", "error", err, data);
          if (_.includes(["manifestLoadError"], data.details)) {
            setLoading(false);
            dispatch(setError("An error occurred_again"));
          }
          // dispatch(setError("An error occurred_again"));
        });
      } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
        const match = /\/hls\/[\w-]{5,}\/\d+.ts/g;
        try {
          _.reduce(
            _.range(0, 20),
            async (prevPromise, indx) => {
              try {
                await prevPromise;
                return new Promise(async (resolve, reject) => {
                  const resp = await axios.get(videoSrc);
                  const matched = match.exec(resp.data);
                  if (!matched) {
                    setTimeout(() => resolve(), 1000);
                  } else {
                    video.src = videoSrc;

                    video.addEventListener("loadedmetadata", function () {
                      video.play();
                    });
                    reject();
                  }
                });
              } catch (err) {
                return Promise.reject();
              }
            },
            Promise.resolve()
          );
        } catch (err) {
          console.log("err", err);
        }
      }
      video.addEventListener("waiting", function () {
        console.log("waiting");
        setLoading(true);
        setPlaying(false);
      });
      video.addEventListener("playing", function () {
        setLoading(false);
        console.log("playing");
        setPlaying(true);
      });

      video.addEventListener("play", function () {
        console.log("play");
        setLoading(false);
        setPlaying(true);
      });

      video.addEventListener("pause", function () {
        console.log("pause");
        setLoading(true);
        setPlaying(false);
      });
    }
  }, [camera, email, loginInfo, disabled, dir, onChannelChange, dispatch]);

  useEffect(() => {
    const changeMic = async () => {
      console.log(
        "CloudNative",
        "changeMic",
        "localStream",
        localStream.current
      );
      try {
        console.log(
          "CloudNative",
          "enableMic",
          enableMic,
          peerConnection.current
        );
        if (!peerConnection.current) return;
        if (enableMic) {
          const stream = await navigator.mediaDevices.getUserMedia({
            video: false,
            audio: {
              autoGainControl: true,
              echoCancellation: true,
              noiseSuppression: false,
            },
          });

          audioStreamRef.current = stream;
          const audioTrack = stream.getAudioTracks()[0];
          // localStream.current.addTrack(audioTrack);
          if (localView.current) {
            localView.current.muted = true;
            localView.current.volume = 0;
          }
          const sender = peerConnection.current
            .getSenders()
            .find((s) => s.track?.kind === "audio");
          console.log("CloudNative", "sender", sender);
          sender?.replaceTrack(audioTrack);

          audioStreamRef.current?.getTracks().forEach((track) => {
            track.onended = (evt) => {
              console.log("CloudNative", "track onended", evt);
              if (audioStreamRef.current) {
                audioStreamRef.current
                  .getTracks()
                  .forEach((track) => track.stop());
              }
              audioStreamRef.current = null;
              onNoMicPerm?.();
            };
          });

          const audioContent = new AudioContext();
          const audioStream = audioContent.createMediaStreamSource(stream);
          const analyser = audioContent.createAnalyser();
          audioStream.connect(analyser);
          analyser.fftSize = 2048;
          analyser.minDecibels = -100;
          analyser.maxDecibels = 0;
          analyser.smoothingTimeConstant = 0.8;
          const frequencyArray = new Uint8Array(analyser.frequencyBinCount);
          const doDraw = function () {
            analyser.getByteFrequencyData(frequencyArray);
            let adjustedLength = _.slice(frequencyArray, 80, 180);
            setAudioLevel(_.mean(adjustedLength));
          };
          audioAnimationRef.current = setInterval(doDraw, 250);
        } else {
          if (audioStreamRef.current) {
            audioStreamRef.current.getTracks().forEach((track) => track.stop());
          }
          audioStreamRef.current = null;
        }
      } catch (e) {
        console.error("CloudNative", "[Viewer Audio] error: ", e.message);
      }
      // }
    };
    changeMic();
  }, [enableMic, onNoMicPerm]);

  const startCNPlay = useCallback(async () => {
    if (disconnectedRef.current) return true;
    try {
      console.log("CloudNative", "sending PlayLiveView to", camera?.psn);

      const status = await jwtAxiosInst.post(`/IoT/devicecommand`, {
        command: "PlayLiveView",
        email,
        user_token: loginInfo?.user_token,
        tokenType: tokenType,
        psn: camera?.psn,
        param1: prevDirectionRef.current
          ? `${prevDirectionRef.current}`
          : undefined,
      });

      let statusBody = status.data;
      if (typeof statusBody === "string") {
        statusBody = JSON.parse(statusBody);
      }

      console.log("CloudNative", "try to startCNPlay", statusBody);
      if (
        !(
          statusBody.status === "LiveStopped" ||
          statusBody.status === "onLiveStreaming"
        )
      ) {
        return false;
      }
      // getEndpoints(presignedUrl, `${camera?.psn}_live`);
      setReadyToConnect(true);
    } catch (e) {
      return false;
    }

    try {
      setServerError(false);
      console.log(
        "CloudNative",
        "play",
        camera?.psn,
        email,
        // kinesisVideoClient,
        loginInfo?.user_token
      );
      return true;
    } catch (e: any) {
      setServerError(true);
      dispatch(setError(e.message));
      console.error(e.message);
    }
    return true;
  }, [camera?.psn, dispatch, email, loginInfo?.user_token, tokenType]);

  const tryPlay = useCallback(async () => {
    let runs = 20;
    let requested = false;
    const playLiveView = async () => {
      if (!requested) {
        requested = true;
        try {
          const s = await startCNPlay();
          runs--;
          if (s || runs <= 0) {
            clearInterval(timer);
          } else {
            console.log("CloudNative", "Dashcam is busy...");
          }
        } finally {
          requested = false;
        }
      }
    };
    playLiveView();
    let timer = setInterval(playLiveView, 2000);
    return timer;
  }, [startCNPlay]);

  const connectLiveView = useCallback(async () => {
    const streamName = `${camera?.psn}_live`;

    const resp2 = await jwtAxiosInst.post(`/CloudService/LivePresignURL`, {
      streamName,
      role: "VIEWER",
      psn: camera?.psn,
    });

    const q1 = new URL(resp2.data.url);
    clientIDRef.current = q1.searchParams.get("X-Amz-ClientId");

    console.log(
      "CloudNative",
      "LivePresignURL",
      resp2.data,
      "clientID",
      clientIDRef.current
    );

    setPresignedUrl(resp2.data);
  }, [camera?.psn]);

  const getEndpoints = useCallback(
    async (presignedUrl: LivePresignURLResult) => {
      if (main && !onNoMicPerm) return;
      if (signalingClient.current) return;
      if (peerConnection.current) return;
      if (localStream.current) return;
      if (remoteStream.current) return;
      // Get signaling channel ARN
      const channelARN = presignedUrl.channelARN;

      console.log(
        "CloudNative",
        "clientID",
        clientIDRef.current,
        "[VIEWER] Channel ARN: ",
        channelARN
      );

      // const endpointsByProtocol = presignedUrl.endpointsByProtocol;
      console.log(
        "CloudNative",
        "clientID",
        clientIDRef.current,
        "[VIEWER] Endpoints: ",
        presignedUrl.url
      );

      const iceServers = presignedUrl.iceServers;

      console.log(
        "CloudNative",
        "clientID",
        clientIDRef.current,
        "[VIEWER] ICE servers: ",
        iceServers
      );
      signalingClient.current = new KVSWebRTC.SignalingClient({
        requestSigner: new CustomSigner(presignedUrl.url),
        channelARN,
        channelEndpoint: presignedUrl.url,
        role: KVSWebRTC.Role.VIEWER,
        region: presignedUrl.region,
        clientId: clientIDRef.current,
        // systemClockOffset: kvsVideo.config.systemClockOffset,
      });

      peerConnection.current = new RTCPeerConnection({
        iceServers,
        iceTransportPolicy: "relay",
      });

      if (disconnectedRef.current) {
        signalingClient.current?.close();
        signalingClient.current = null;
        peerConnection.current?.close();
        peerConnection.current = null;
        return;
      }

      // Once the signaling channel connection is open, connect to the webcam and create an offer to send to the master
      let noAudio = false;
      signalingClient.current?.on("open", async () => {
        console.log(
          "CloudNative",
          "clientID",
          clientIDRef.current,
          "[VIEWER] Connected to signaling service",
          "navigator.mediaDevices",
          !!navigator.mediaDevices
        );
        // Get a stream from the webcam, add it to the peer connection, and display it in the local view
        try {
          localStream.current = await navigator.mediaDevices.getUserMedia({
            // video: { width: { ideal: 640 }, height: { ideal: 480 } },
            video: false,
            // audio: false,
            audio: isPublic
              ? false
              : {
                  // autoGainControl: true,
                  // echoCancellation: true,
                  // noiseSuppression: false,
                },
          });
          localStream.current?.getTracks().forEach((track: any) => {
            if (localStream.current) {
              peerConnection.current?.addTrack(track, localStream.current);
            }
          });
          // 마이크 disable
          // if (localStream.current) {
          //   const track = _.first(localStream.current.getAudioTracks());
          //   if (track) {
          //     track.enabled = false;
          //   }
          // }

          // if (localView.current) {
          //   localView.current.srcObject = localStream.current;
          // }
        } catch (e) {
          // Could not find webcam
          console.error(
            "CloudNative",
            "clientID",
            clientIDRef.current,
            "[VIEWER] Could not find webcam",
            e.message,
            browserName
          );
          console.log(
            "CloudNative",
            "clientID",
            clientIDRef.current,
            "onNoMicPerm"
          );
          if (browserName === "ios-webview" && navigator.mediaDevices) {
            onNoMicPerm?.(true);
          } else if (browserName !== "chromium-webview") {
            onNoMicPerm?.();
          }
          noAudio = true;
        }

        try {
          const transceiver = peerConnection.current?.addTransceiver("video");
          if (transceiver) {
            transceiver.direction = "recvonly";
          }

          if (noAudio) {
            const audioTransceiver =
              peerConnection.current?.addTransceiver("audio");
            if (audioTransceiver) {
              audioTransceiver.direction = "recvonly";
            }
          }
        } catch (e) {
          console.error(e.message);
        }

        // Create an SDP offer and send it to the master
        const offer = await peerConnection.current?.createOffer({
          offerToReceiveAudio: true,
          offerToReceiveVideo: true,
        });
        console.log(
          "CloudNative",
          "clientID",
          clientIDRef.current,
          "[VIEWER] Creating SDP offer",
          offer?.sdp,
          {
            ...offer,
            // sdp: offer?.sdp?.replace(
            //   "a=group:BUNDLE audio video",
            //   "a=group:BUNDLE 0 1"
            // ),
          }
        );
        if (offer && offer.sdp) {
          // offer.sdp = offer.sdp.replace(
          //   "a=group:BUNDLE audio video",
          //   "a=group:BUNDLE 0 1"
          // );
          await peerConnection.current?.setLocalDescription(offer);
          if (peerConnection.current?.localDescription) {
            // 대시캠에서 SDP offer를 못받는 이슈가 있어서,
            // sdp offer 보낸 후, sdp answer를 못받으면
            // 받을때 까지 2초간격으로 5회까지 sdp offer를 다시 보냄
            const timer = setInterval(() => {
              console.log(
                "CloudNative",
                "clientID",
                clientIDRef.current,
                "[VIEWER] Sending SDP offer",
                nTrySendSDPRef.current,
                receivedSDPRef.current
              );
              if (nTrySendSDPRef.current > 5 || receivedSDPRef.current) {
                if (nTrySendSDPRef.current > 5) {
                  setServerError(true);
                }
                return clearInterval(timer);
              }
              if (peerConnection.current?.localDescription) {
                signalingClient.current?.sendSdpOffer(
                  peerConnection.current.localDescription
                );
              }
              nTrySendSDPRef.current++;
            }, 5000);
            console.log(
              "CloudNative",
              "clientID",
              clientIDRef.current,
              "[VIEWER] Sending SDP offer"
            );

            await sleep(100);
            signalingClient.current?.sendSdpOffer(
              peerConnection.current.localDescription
            );
            sendingSDPRef.current = true;
          }
        }
        console.log(
          "CloudNative",
          "clientID",
          clientIDRef.current,
          "[VIEWER] Generating ICE candidates"
        );

        if (disconnectedRef.current) {
          signalingClient.current?.close();
          signalingClient.current = null;
          peerConnection.current?.close();
          peerConnection.current = null;

          if (localStream.current) {
            localStream.current.getTracks().forEach((track) => track.stop());
            localStream.current = null;
          }
          if (remoteStream.current) {
            remoteStream.current.getTracks().forEach((track) => track.stop());
            remoteStream.current = null;
          }
          return;
        }
      });

      // When the SDP answer is received back from the master, add it to the peer connection.
      signalingClient.current?.on("sdpAnswer", async (answer) => {
        console.log(
          "CloudNative",
          "clientID",
          clientIDRef.current,
          "[VIEWER] Received SDP answer",
          answer.sdp
        );
        receivedSDPRef.current = true;
        await peerConnection.current?.setRemoteDescription(answer);
      });

      // When an ICE candidate is received from the master, add it to the peer connection.
      signalingClient.current?.on("iceCandidate", (candidate) => {
        console.log(
          "CloudNative",
          "clientID",
          clientIDRef.current,
          "[VIEWER] Received ICE candidate"
        );
        peerConnection.current?.addIceCandidate(candidate);
      });

      signalingClient.current?.on("close", () => {
        console.log(
          "CloudNative",
          "clientID",
          clientIDRef.current,
          "[VIEWER] Disconnected from signaling channel"
        );
        // Handle client closures
      });

      signalingClient.current?.on("error", (error) => {
        console.error(
          "CloudNative",
          "clientID",
          clientIDRef.current,
          "[VIEWER] Signaling client error: ",
          error
        );
        // Handle client errors
      });
      // Send any ICE candidates generated by the peer connection to the other peer
      peerConnection.current?.addEventListener(
        "icecandidate",
        ({ candidate }) => {
          if (disconnectedRef.current) {
            signalingClient.current?.close();
            signalingClient.current = null;
            peerConnection.current?.close();
            peerConnection.current = null;

            if (localStream.current) {
              localStream.current.getTracks().forEach((track) => track.stop());
              localStream.current = null;
            }
            if (remoteStream.current) {
              remoteStream.current.getTracks().forEach((track) => track.stop());
              remoteStream.current = null;
            }
            return;
          }
          if (candidate) {
            console.log(
              "CloudNative",
              "clientID",
              clientIDRef.current,
              "[VIEWER] Generated ICE candidate"
            );
            console.log(
              "CloudNative",
              "clientID",
              clientIDRef.current,
              "[VIEWER] Sending ICE candidate"
            );
            signalingClient.current?.sendIceCandidate(candidate);
          }
        }
      );

      // As remote tracks are received, add them to the remote view
      peerConnection.current?.addEventListener("track", (event) => {
        console.log(
          "CloudNative",
          "clientID",
          clientIDRef.current,
          "[VIEWER] Received remote track",
          event
        );
        if (remoteView.current && !remoteView.current.srcObject) {
          remoteStream.current = event.streams[0];
          remoteView.current.srcObject = event.streams[0];
        }
      });

      peerConnection.current?.addEventListener(
        "iceconnectionstatechange",
        (event) => {
          console.log(
            "CloudNative",
            "clientID",
            clientIDRef.current,
            "[VIEWER] Iceconnection State Change",
            event
          );
        }
      );

      peerConnection.current?.addEventListener(
        "connectionstatechange",
        async (event) => {
          console.log(
            "CloudNative",
            "clientID",
            clientIDRef.current,
            "[VIEWER] Connection State Change",
            event,
            peerConnection.current?.connectionState
          );
          // setReadyToPlay(true);
          if (peerConnection.current?.connectionState === "connected") {
            setLoading(false);

            if (localStream.current) {
              localStream.current.getTracks().forEach((track) => {
                track.stop();
                localStream.current?.removeTrack(track);
              });
              localStream.current = null;
              // const audioTrack = localStream.current.getAudioTracks()[0];
              // if (audioTrack) {
              //   audioTrack.stop();
              //   localStream.current.removeTrack(audioTrack);
              // }
            }
          } else if (
            peerConnection.current?.connectionState === "disconnected"
          ) {
            console.log("disconnected.........");
            await resetConnection();
            connectLiveView();
            retryTimer.current = await tryPlay();
          }
        }
      );
      // setEndpointsByProtocol(result);
      console.log(
        "CloudNative",
        "clientID",
        clientIDRef.current,
        "[VIEWER] Starting viewer connection",
        disconnectedRef.current
      );
      if (disconnectedRef.current) {
        signalingClient.current?.close();
        signalingClient.current = null;
        peerConnection.current?.close();
        peerConnection.current = null;
        return;
      } else {
        signalingClient.current?.open();
      }
    },
    [
      browserName,
      connectLiveView,
      isPublic,
      main,
      onNoMicPerm,
      resetConnection,
      tryPlay,
    ]
  );

  useEffect(() => {
    if (presignedUrl && readyToConnect && !disconnectedRef.current) {
      console.log(
        "CloudNative",
        "clientID",
        clientIDRef.current,
        "start getEndpoints",
        disconnectedRef.current
      );
      getEndpoints(presignedUrl);
    }
  }, [getEndpoints, presignedUrl, readyToConnect]);

  useEffect(() => {
    if (camera) {
      const cam = camera;
      const p = remoteView.current;
      const local = localView.current;

      return async () => {
        if (!CLOUD_NATIVE) return;
        console.log(
          "CloudNative",
          "clientID",
          clientIDRef.current,
          "start removing connection..."
        );
        disconnectedRef.current = true;
        if (retryTimer.current !== undefined) {
          clearInterval(retryTimer.current);
        }
        if (audioStreamRef.current) {
          console.log(
            "CloudNative",
            "clientID",
            clientIDRef.current,
            "sending TwoWayStop to",
            cam.psn
          );
          audioStreamRef.current.getTracks().forEach((track) => track.stop());
          audioStreamRef.current = null;
          jwtAxiosInst.post(`/IoT/devicecommand`, {
            command: "TwoWayStop",
            email,
            user_token: loginInfo?.user_token,
            tokenType: tokenType,
            psn: cam.psn,
          });
        }

        await sleep(1500);

        if (!sendingSDPRef.current) {
          // kvs 채널 연결이 정상적으로 되지 않은 경우를 대비해 Stop메시지 추가로 보냄 (20220714)
          // TwoWayStart한 경우는 라이브뷰 정상연결된 경우로 StopLiveView 안보냄
          console.log(
            "CloudNative",
            "clientID",
            clientIDRef.current,
            "sending StopLiveView to",
            cam.psn
          );
          jwtAxiosInst.post(`/IoT/devicecommand`, {
            command: "StopLiveView",
            email,
            user_token: loginInfo?.user_token,
            tokenType: tokenType,
            psn: cam.psn,
          });
        }

        console.log(
          "CloudNative",
          "clientID",
          clientIDRef.current,
          "removing webrtc...",
          cam.psn
        );
        p?.pause();
        local?.pause();
        setHlsInst(undefined);
        setPresignedUrl(undefined);
        setReadyToConnect(false);

        console.log(
          "CloudNative",
          "clientID",
          clientIDRef.current,
          "close signaling client...",
          cam.psn,
          signalingClient.current
        );
        // webrtc 정리
        if (signalingClient.current) {
          signalingClient.current.close();
          signalingClient.current = null;
        }

        if (peerConnection.current) {
          peerConnection.current.close();
          peerConnection.current = null;
        }

        if (localStream.current) {
          localStream.current.getTracks().forEach((track) => track.stop());
          localStream.current = null;
        }

        if (remoteStream.current) {
          remoteStream.current.getTracks().forEach((track) => track.stop());
          remoteStream.current = null;
        }

        if (local) {
          local.srcObject = null;
        }

        if (p) {
          p.srcObject = null;
        }

        disconnectedRef.current = false;
      };
    }
  }, [CLOUD_NATIVE, camera, email, loginInfo?.user_token, tokenType]);

  useEffect(() => {
    if (CLOUD_NATIVE && !disabled && autoPlayable !== undefined && camera) {
      stopLiveview.current = true;

      connectLiveView();
    }
  }, [CLOUD_NATIVE, autoPlayable, camera, connectLiveView, disabled]);

  useEffect(() => {
    if (CLOUD_NATIVE && !disabled && autoPlayable !== undefined && camera) {
      // 연결 시도 타이머
      let t: any;

      tryPlay().then((v) => (t = v));
      return () => {
        if (t) {
          clearInterval(t);
        }
      };
    }
  }, [CLOUD_NATIVE, autoPlayable, camera, disabled, tryPlay]);

  useEffect(() => {
    if (CLOUD_NATIVE === false && autoPlayable !== undefined) {
      startPlay();
    }
  }, [CLOUD_NATIVE, startPlay, autoPlayable]);

  useEffect(() => {
    if (hlsInst) {
      const hls = hlsInst;
      return () => {
        hls.destroy();
      };
    }
  }, [hlsInst]);

  const renderCtrlIcon = useCallback(
    (icon: React.ReactNode, onClick?: () => void, disabled?: boolean) => {
      return disabled ? (
        <span className={classes.disabledCtrlIcon}>{icon}</span>
      ) : (
        <IconButton
          className={classes.ctrlIcon}
          onClick={(e) => {
            e.stopPropagation();
            onClick?.();
          }}
        >
          {icon}
        </IconButton>
      );
    },
    [classes.ctrlIcon, classes.disabledCtrlIcon]
  );

  const volumeCtrlMarkup = useMemo(() => {
    const noVolume = isPublic && camera?.share_audio !== "on";
    let volumeIcon = (
      <Tooltip
        // mantis - 9178, 웹 제외. 모든 툴팁 최초 진입시에만 노출(Leehj).
        open={openMuteTooltip}
        onOpen={() => setOpenMuteTooltip(true)}
        onClose={() => setOpenMuteTooltip(false)}
        disableTouchListener={app || mobile}
        disableHoverListener={app || mobile}
        PopperProps={{
          disablePortal: true,
          modifiers: {
            preventOverflow: { enabled: false },
            offset: {
              enabled: true,
              offset: mobile ? "0px, -25px" : "2px, -10px",
            },
            flip: {
              enabled: false,
            },
          },
        }}
        title={
          <Typography category="Default" variant="Caption">
            {t("Mute")}
          </Typography>
        }
        placement="top-start"
      >
        <IconButton
          className={classes.ctrlIcon}
          ref={volumeAnchorRef}
          disableHover={mobile}
          onClick={(e) => {
            e.stopPropagation();
            setMuted(true);
            setPreVolume(volume);
            setVolume(0);
          }}
        >
          <VolumeUpIcon />
        </IconButton>
      </Tooltip>
    );
    if (muted) {
      volumeIcon = (
        <Tooltip
          // mantis - 9178, 웹 제외. 모든 툴팁 최초 진입시에만 노출(Leehj).
          open={openUnMuteTooltip}
          onOpen={() => setOpenUnMuteTooltip(true)}
          onClose={() => setOpenUnMuteTooltip(false)}
          disableTouchListener={app || mobile}
          disableHoverListener={app || mobile}
          PopperProps={{
            disablePortal: true,
            modifiers: {
              preventOverflow: { enabled: false },
              offset: {
                enabled: true,
                offset: mobile ? "0px, -25px" : "2px, -10px",
              },
              flip: {
                enabled: false,
              },
            },
          }}
          title={
            <Typography category="Default" variant="Caption">
              {t("UnMute")}
            </Typography>
          }
          placement="top-start"
        >
          <IconButton
            className={classes.ctrlIcon}
            ref={volumeAnchorRef}
            disableHover={mobile}
            onClick={(e) => {
              // 라이브 음성 미공유 시, unmute버튼 눌러도 동작하지 않도록 예외처리 추가 (7271)
              if (!disableVolume) {
                e.stopPropagation();
                setMuted(false);
                if (preVolume === 0) {
                  setVolume(mobile ? 100 : 50);
                } else {
                  setVolume(preVolume);
                }
              }
            }}
          >
            <VolumeOffIcon />
          </IconButton>
        </Tooltip>
      );
    }
    return (
      <div className={classes.ctrlDiv}>
        {
          <div
            style={{ display: "flex", alignItems: "center" }}
            onMouseEnter={() => !disableVolume && setOpenVolumeMenu(true)}
            onMouseLeave={() => !disableVolume && setOpenVolumeMenu(false)}
          >
            {!noVolume && volumeIcon}
            {!noVolume && !muted && !mobile && openVolumeMenu && (
              <div className={classes.volumeCtrlDiv}>
                <VolumeSlider
                  value={volume}
                  onChange={(e, newVal) => setVolume(newVal as number)}
                />
              </div>
            )}
          </div>
        }
        <div>
          <Tooltip
            disableTouchListener={mobile}
            title={
              <Typography category="Default" variant="Caption">
                {t("Flip")}
              </Typography>
            }
            placement="top"
            PopperProps={{
              disablePortal: true,
              modifiers: {
                preventOverflow: { enabled: false },
                offset: {
                  enabled: true,
                  offset: mobile ? "0px, -25px" : "2px, -10px",
                },
                flip: {
                  enabled: false,
                },
              },
            }}
          >
            <IconButton
              className={classes.ctrlIcon}
              ref={flipAnchorRef}
              onClick={() => setOpenFlipMenu((f) => !f)}
            >
              <FlipIcon />
            </IconButton>
          </Tooltip>

          <Tooltip
            disableTouchListener={mobile}
            open={openTooltip}
            onOpen={() => setOpenTooltip(true)}
            onClose={() => setOpenTooltip(false)}
            title={
              <Typography category="Default" variant="Caption">
                {fullscreen ? t("Exit fullscreen") : t("Fullscreen")}
              </Typography>
            }
            placement="top-end"
            PopperProps={{
              disablePortal: true,
              modifiers: {
                preventOverflow: { enabled: false },
                offset: {
                  enabled: true,
                  offset: mobile ? "0px, -25px" : "2px, -10px",
                },
                flip: { enabled: false },
              },
            }}
          >
            <IconButton className={classes.ctrlIcon} onClick={handleFullscreen}>
              {fullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
            </IconButton>
          </Tooltip>
        </div>
      </div>
    );
  }, [
    app,
    camera?.share_audio,
    classes.ctrlDiv,
    classes.ctrlIcon,
    classes.volumeCtrlDiv,
    disableVolume,
    fullscreen,
    handleFullscreen,
    isPublic,
    mobile,
    muted,
    openMuteTooltip,
    openTooltip,
    openUnMuteTooltip,
    openVolumeMenu,
    preVolume,
    t,
    volume,
  ]);

  return (
    <div
      ref={videoRef}
      className={clsx(classes.root, {
        [classes.fullscreenRoot]: fullscreen,
      })}
    >
      <div
        ref={fullScreenRef}
        className={clsx(classes.videoDiv, {
          [classes.multiViewDiv]: multiView,
          [classes.videoFullScreen]: fullscreen,
          [classes.videoDivApp]: app,
          [classes.videoDivAppLandscape]: app && landscape,
        })}
      >
        <div
          className={clsx(classes.video, {
            [classes.videoHFlip]: !vFlip && hFlip,
            [classes.videoVFlip]: vFlip && !hFlip,
            [classes.videoFlip]: vFlip && hFlip,
          })}
        >
          <video
            style={{
              width: "100%",
              height: "100%",
              transform: remoteTransform,
            }}
            ref={remoteView}
            className="video-js"
            // playsInline
            webkit-playsinline
            autoPlay
            playsInline
            // controls
            muted={muted && volume === 0}
            // muted
            onPlay={() => setLoading(false)}
            onError={(e) => console.log("video error", e)}
          />
          <video
            ref={localView}
            className="video-js"
            autoPlay
            webkit-playsinline
            playsInline
            controls
            muted
            style={{ width: 0, height: 0 }}
          />
        </div>
        <div
          className={clsx(classes.overlayDiv, {
            [classes.selectedOverlay]: multiView && selected && !fullscreen,
          })}
        >
          {(multiView || fullscreen) && camera && (
            <div className={clsx(classes.menuDiv)}>
              <Typography
                category="Default"
                variant="Small"
                htmlColor={
                  main && !fullscreen ? LightColors.secondary["17"] : undefined
                }
                style={{ flex: 1 }}
              >
                {camera && `${camera.dev_name} (${camera.model})`}
                {main && !fullscreen && ` · ${t("Main")}`}
              </Typography>
              <div style={{ display: "flex", alignItems: "center" }}>
                {CLOUD_NATIVE &&
                  !isPublic &&
                  (multiView || fullscreen) &&
                  userProfile?.userType !== "User" && (
                    <div style={{ marginRight: 18 }}>
                      <MicToggle
                        enableMic={enableMic ?? false}
                        volume={audioLevel}
                        onToggleMic={onToggleMic ? onToggleMic : () => {}}
                        disabled={micBtnDisabled || !playing}
                        loading={loadingTwoWay}
                      />
                    </div>
                  )}
                {!isPublic && (
                  // 7027 - 방향 전환 시, 5초간 방향전환 못하게 수정
                  <div
                    className={clsx(classes.dirDiv, {
                      [classes.disabled]: disableDir || !playing,
                    })}
                    ref={menuAnchorRef}
                    // mantis - 8669, 비활성화 상태일 때는 클릭 시 메뉴 나오지 않도록 수정
                    onClick={() => {
                      if (!disableDir && playing) {
                        setOpenMenu(true);
                      }
                    }}
                  >
                    <Typography category="Default" variant="BodyBold">
                      {t(getDirection(direction ?? 1, isOptionModel))}
                    </Typography>
                    <ExpandMoreIcon
                      fontSize="small"
                      style={{
                        fill: disableDir
                          ? `${LightColors.primary["0"]}40`
                          : undefined,
                      }}
                    />
                  </div>
                )}
                {!main && !fullscreen && (
                  <IconButton
                    color="primary"
                    onClick={() => {
                      setHlsInst(undefined);
                      onClose?.();
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                )}
              </div>
            </div>
          )}
        </div>
        {loading && !serverError && (
          <div
            className={classes.overlayDiv}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress
              className={classes.circularLoading}
              size={48}
              thickness={5}
            />
          </div>
        )}
        {serverError && (
          <div
            className={classes.overlayDiv}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              category="Default"
              variant={mobile ? "Body" : "H2"}
              htmlColor={LightColors.primary["0"]}
            >
              {t("Internal Server Error or Request Timeout")}
            </Typography>
          </div>
        )}

        {twoWayInUse && (
          <div
            className={clsx(classes.twoWayAlert, {
              [classes.twoWayAlertMulti]: multiView || fullscreen,
            })}
          >
            <Alerts severity="warning" mode="web">
              {t("Voice call in use")}
            </Alerts>
          </div>
        )}

        {directionChangeFailed && (
          <div
            className={clsx(classes.twoWayAlert, {
              [classes.twoWayAlertMulti]: multiView,
            })}
          >
            <Alerts severity="warning" mode="web">
              {t("Direction change failed")}
            </Alerts>
          </div>
        )}

        {refresh && (
          <div className={classes.mobilePlayCtrlDiv}>
            <div className={classes.mobilePlayCtrl}>
              {renderCtrlIcon(
                <RefreshIcon style={{ fontSize: "3rem" }} />,
                startPlay
              )}
            </div>
          </div>
        )}
        <div
          className={clsx(classes.ctrlContDiv, {
            [classes.ctrlContDivFullscreenApp]:
              app && browserName === "chromium-webview" && fullscreen,
          })}
        >
          {volumeCtrlMarkup}
        </div>

        {!main && !camera && (
          <div className={classes.addCameraDiv}>
            <div
              className={classes.addCameraBtn}
              onClick={() => onAddCamera?.()}
            >
              <AddCircleOutlineIcon style={{ marginBottom: 8 }} />
              <Typography category="Default" variant="Body">
                {t("Add camera")}
              </Typography>
            </div>
          </div>
        )}
        {mobile && (
          <MobileMenu
            open={openFlipMenu}
            onClose={() => setOpenFlipMenu(false)}
            container={fullScreenRef.current}
          >
            <WebMenuItem
              className={clsx(classes.mobileMemuItem)}
              onClick={() => {
                setOpenFlipMenu(false);
                setHFlip((f) => !f);
              }}
            >
              {t("Flip horizontally")}
            </WebMenuItem>

            <WebMenuItem
              className={clsx(classes.mobileMemuItem)}
              onClick={() => {
                setOpenFlipMenu(false);
                setVFlip((f) => !f);
              }}
            >
              {t("Flip vertically")}
            </WebMenuItem>
          </MobileMenu>
        )}
        {!mobile && (
          <Menu
            style={{ zIndex: 2147483647 }}
            paperClasses={{ root: classes.playerMenuDiv }}
            open={openFlipMenu}
            anchorEl={flipAnchorRef.current}
            onClickAway={() => setOpenFlipMenu(false)}
            placement="top"
          >
            <WebMenuItem
              className={clsx(classes.webMenuDiv)}
              onClick={() => {
                setOpenFlipMenu(false);
                setHFlip((f) => !f);
              }}
            >
              {t("Flip horizontally")}
            </WebMenuItem>

            <WebMenuItem
              className={clsx(classes.webMenuDiv)}
              onClick={() => {
                setOpenFlipMenu(false);
                setVFlip((f) => !f);
              }}
            >
              {t("Flip vertically")}
            </WebMenuItem>
          </Menu>
        )}
        {mobile && (
          <MobileMenu
            open={openMenu}
            container={fullScreenRef.current}
            onClose={() => setOpenMenu(false)}
          >
            {directionMenuMarkup}
          </MobileMenu>
        )}
        {!mobile && (
          <Menu
            style={{ zIndex: 2147483647 }}
            open={openMenu}
            anchorEl={menuAnchorRef?.current}
            onClickAway={() => setOpenMenu(false)}
            placement="bottom-end"
            disablePortal
            modifiers={{
              preventOverflow: { enabled: false },
              offset: {
                enabled: true,
                offset: "0px, 20px",
              },
              flip: {
                enabled: false,
              },
            }}
          >
            {directionMenuMarkup}
          </Menu>
        )}
        {/* mantis - 9266, 전체화면시에도 토스트팝업 노출되도록 수정(Leehj) */}
        {fullscreen && (
          <Toast
            open={openUnplugged}
            message={t("Camera is unplugged")}
            onClose={() => {
              setTimeout(() => setOpenUnplugged(false), 6000);
            }}
          />
        )}
      </div>
      {/* 
          // mantis : 7394
          // Live view 연결 끊겼을 때 모달
           */}
      <Modal
        open={liveModal}
        onClose={() => setLiveModal(false)}
        onClickPositive={() => {
          //10604 - 퍼블릭 대시캠 연결 끊긴 경우 앱에서는 뒤로가기 메시지 전달하도록 수정 (mckim)
          if (app) {
            dispatch(finishLiveview("DEVICE_DISCONNECT"));
          } else {
            setLiveModal(false);
            history.push("/cameras");
          }
        }}
        heading="Camera disconnected from the Cloud."
        content={""}
        RButton="OK"
      />
    </div>
  );
};
